module.exports = __webpack_public_path__ + "media/footer/twitter-7b599a7e.svg";